// extracted by mini-css-extract-plugin
module.exports = {"map":"Location_map__2TVuU"};